import { createGlobalStyle } from 'styled-components';

import colors from './variables/colors';

export default createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400&family=JetBrains+Mono:wght@400;500;600&display=swap');

  * {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
  }

  html, body, #root {
    min-height: 100%;
  }

  body {
    font-family: 'Plus Jakarta Sans', system-ui, -apple-system, sans-serif;
    background: ${colors.pageBg};
    color: ${colors.textOnDark};
    line-height: 1.6;
    -webkit-font-smoothing: antialiased;
  }

  body, input, button, textarea {
    font-family: 'Plus Jakarta Sans', system-ui, -apple-system, sans-serif;
  }

  *:focus-visible {
    outline: 2px solid ${colors.yellow};
    outline-offset: 2px;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  ul {
    list-style: none;
  }

  button {
    cursor: pointer;
    border: none;
    background: none;
    font: inherit;
  }
`;
